import { Reveal } from "./Reveal";
import { ClipboardCheck, PackageCheck, Radio, CheckCheck } from "lucide-react";

const stages = [
  { icon: ClipboardCheck, t: "Booking Confirmation" },
  { icon: PackageCheck, t: "Pickup Update" },
  { icon: Radio, t: "Transit or Border Update" },
  { icon: CheckCheck, t: "Delivery Confirmation" },
];

export const Visibility = () => (
  <section className="bg-oyf-grey py-20 md:py-28" data-testid="visibility">
    <div className="container-oyf">
      <div className="grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-[2px] w-8 bg-oyf-yellow" />
            <span className="text-xs font-bold tracking-[0.2em] uppercase text-oyf-medgrey">Shipment Visibility</span>
          </div>
          <h2 className="font-display font-extrabold text-oyf-black tracking-tight text-3xl md:text-5xl leading-[1.02]">
            Communication Is Part of the Delivery
          </h2>
          <p className="mt-5 text-oyf-medgrey text-base md:text-lg leading-relaxed">
            Customers need more than a vehicle. They need clear information. One York Freight emphasizes organized communication from the original inquiry through pickup, transit, border coordination and final delivery.
          </p>
          <div className="mt-8 border-l-4 border-oyf-yellow bg-white rounded-r-lg p-6">
            <p className="font-display font-extrabold text-oyf-black text-xl md:text-2xl leading-snug">
              &ldquo;Fast freight should never mean unclear communication.&rdquo;
            </p>
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
          {stages.map((s, i) => (
            <Reveal key={s.t} delay={i * 0.08}>
              <div className="relative h-full bg-white rounded-lg p-6 border border-oyf-grey hover:border-oyf-yellow transition-colors duration-300">
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-md bg-oyf-yellow flex items-center justify-center">
                    <s.icon size={22} className="text-oyf-black" />
                  </div>
                  <span className="font-display font-extrabold text-oyf-grey text-2xl">{String(i + 1).padStart(2, "0")}</span>
                </div>
                <h3 className="font-display font-bold text-oyf-black text-lg mt-4">{s.t}</h3>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
